import { RECEIPT_CHANNELS, isChannelAvailable } from 'lib/helpers/receiptDelivery';

import Button from 'components/shared/Button/Button';

// Same look as the receipt sheet's header actions (ReceiptSendActions).
const actionProps = {
  variant: 'link',
  size: 'small',
  color: 'neutral',
  iconSize: 16,
  shade: 700,
  iconShade: 700,
  iconColor: 'neutral',
  className: 'gap-1.5'
};

/**
 * Download / Email / Text actions for a document sheet's modal header, wired to useDocumentShare.
 * Email and Text show only when there is something to send for (`canSend`) and the practice and
 * patient allow that channel (`channels`, from the backend; unknown shows both).
 */
const DocumentShareActions = ({ busy, onDownload, onSend, canSend = true, channels }) => (
  <>
    <Button
      {...actionProps}
      text="Download"
      icon="file-download-mono"
      isLoading={busy === 'download'}
      onClick={onDownload}
      data-qa="document-download"
    />
    {canSend && isChannelAvailable(channels, RECEIPT_CHANNELS.EMAIL) && (
      <Button
        {...actionProps}
        text="Email"
        icon="mail-mono"
        isLoading={busy === 'email'}
        onClick={() => onSend('email')}
        data-qa="document-email"
      />
    )}
    {canSend && isChannelAvailable(channels, RECEIPT_CHANNELS.SMS) && (
      <Button
        {...actionProps}
        text="Text"
        icon="message-mono"
        isLoading={busy === 'text'}
        onClick={() => onSend('text')}
        data-qa="document-text"
      />
    )}
  </>
);

export default DocumentShareActions;
